import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export function AffiliatePage() {
  const { code } = useParams()
  const [auth, setAuth] = useState(false)
  const [password, setPassword] = useState('')
  const [error, setError] = useState(false)
  const [data, setData] = useState<any>(null)
  const [conversions, setConversions] = useState<any[]>([])
  const [loading, setLoading] = useState(false)

  const login = async () => {
    setLoading(true)
    const { data: aff } = await supabase.from('affiliates').select('*').eq('code', code).single()
    if (aff && aff.password === password) {
      setData(aff)
      const { data: conv } = await supabase.from('affiliate_conversions').select('*').eq('affiliate_code', code).order('created_at', { ascending: false })
      setConversions(conv || [])
      setAuth(true)
    } else {
      setError(true)
    }
    setLoading(false)
  }

  if (!auth) return (
    <div style={{ minHeight: '100vh', backgroundColor: '#F8F9FA', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ backgroundColor: 'white', borderRadius: 20, padding: 40, maxWidth: 360, width: '90%', textAlign: 'center', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>✦</div>
        <h2 style={{ margin: '0 0 4px', fontSize: 22, fontWeight: 800 }}>Dashboard Affiliato</h2>
        <p style={{ color: '#6B7280', fontSize: 14, marginBottom: 24 }}>Codice: <strong>{code}</strong></p>
        <input
          type='password'
          value={password}
          onChange={e => { setPassword(e.target.value); setError(false) }}
          onKeyDown={e => e.key === 'Enter' && login()}
          placeholder='Password'
          style={{ width: '100%', border: error ? '2px solid #EF4444' : '1px solid #E5E7EB', borderRadius: 10, padding: '12px 16px', fontSize: 15, boxSizing: 'border-box' as any, marginBottom: 8 }}
        />
        {error && <div style={{ color: '#EF4444', fontSize: 13, marginBottom: 8 }}>Password errata</div>}
        <button onClick={login} disabled={loading} style={{ width: '100%', backgroundColor: '#1c3fff', color: 'white', border: 'none', borderRadius: 10, padding: '13px 0', fontSize: 15, fontWeight: 700, cursor: 'pointer', marginTop: 8 }}>
          {loading ? 'Accesso...' : 'Accedi'}
        </button>
      </div>
    </div>
  )

  const appUrl = window.location.origin
  const refLink = appUrl + '?ref=' + code

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#F8F9FA' }}>
      <header style={{ backgroundColor: '#1c3fff', padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <div style={{ color: 'white', fontWeight: 800, fontSize: 18 }}>✦ Dashboard Affiliato</div>
          <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13 }}>Ciao, {data.name}!</div>
        </div>
        <button onClick={() => setAuth(false)} style={{ color: 'rgba(255,255,255,0.7)', backgroundColor: 'transparent', border: 'none', cursor: 'pointer', fontSize: 13 }}>Esci</button>
      </header>

      <div style={{ maxWidth: 700, margin: '0 auto', padding: '24px 16px' }}>

        {/* Stats */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 20 }}>
          {[
            { label: 'Click totali', value: data.clicks, icon: '👆' },
            { label: 'Conversioni', value: data.conversions, icon: '✅' },
            { label: 'Guadagni', value: '€' + (data.earnings || 0).toFixed(2), icon: '💰' },
          ].map(s => (
            <div key={s.label} style={{ backgroundColor: 'white', borderRadius: 12, padding: '16px', border: '1px solid #E5E7EB', textAlign: 'center' }}>
              <div style={{ fontSize: 22 }}>{s.icon}</div>
              <div style={{ fontSize: 24, fontWeight: 800, color: '#111827', marginTop: 4 }}>{s.value}</div>
              <div style={{ fontSize: 12, color: '#6B7280', marginTop: 2 }}>{s.label}</div>
            </div>
          ))}
        </div>

        {/* Link affiliato */}
        <div style={{ backgroundColor: 'white', borderRadius: 12, padding: 20, border: '1px solid #E5E7EB', marginBottom: 20 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: '#111827', marginBottom: 8 }}>🔗 Il tuo link affiliato</div>
          <div style={{ backgroundColor: '#F3F4F6', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#374151', wordBreak: 'break-all', marginBottom: 8 }}>{refLink}</div>
          <button onClick={() => navigator.clipboard.writeText(refLink)} style={{ backgroundColor: '#EEF2FF', color: '#1c3fff', border: 'none', borderRadius: 8, padding: '8px 16px', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
            📋 Copia link
          </button>
        </div>

        {/* Commissioni info */}
        <div style={{ backgroundColor: '#FFFBEB', borderRadius: 12, padding: 16, border: '1px solid #FDE68A', marginBottom: 20 }}>
          <div style={{ fontSize: 13, color: '#92400E', fontWeight: 600 }}>💡 Come funziona</div>
          <div style={{ fontSize: 13, color: '#78350F', marginTop: 6 }}>
            Guadagni il {data.commission_rate}% su ogni abbonamento Premium attivato tramite il tuo link (€{(2.99 * data.commission_rate / 100).toFixed(2)}/mese per utente). Pagamento mensile via bonifico sopra €20.
          </div>
        </div>

        {/* Storico conversioni */}
        <div style={{ backgroundColor: 'white', borderRadius: 12, border: '1px solid #E5E7EB', overflow: 'hidden' }}>
          <div style={{ padding: '16px 20px', borderBottom: '1px solid #E5E7EB', fontWeight: 700, fontSize: 14 }}>📊 Storico conversioni</div>
          {conversions.length === 0 ? (
            <div style={{ padding: 32, textAlign: 'center', color: '#9CA3AF', fontSize: 14 }}>Nessuna conversione ancora — condividi il tuo link!</div>
          ) : (
            conversions.map((c, i) => (
              <div key={c.id} style={{ padding: '12px 20px', borderBottom: i < conversions.length - 1 ? '1px solid #F3F4F6' : 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontSize: 13, color: '#6B7280' }}>{new Date(c.created_at).toLocaleDateString('it-IT')}</div>
                <div style={{ fontSize: 14, fontWeight: 600, color: '#16A34A' }}>+€{c.amount.toFixed(2)}</div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  )
}
